import { sessionApiClient } from "@planningcenter/cc-api-client"
import { useSuspenseQuery } from "@tanstack/react-query"
import { mergeResourcesIncludedIntoRelationships } from "source/publishing/sermons/shared/resource"
import { ChurchCenterCustomFieldAPIRecordWithIncluded } from "source/publishing/sermons/shared/types"

export function useCustomFields(profileId: string) {
  const queryParams =
    "include=field_definition,field_data,field_options&fields[FieldData]=value,file,file_content_type,file_name,file_size&per_page=40"

  return useSuspenseQuery({
    queryKey: ["people", profileId, "church_center_custom_fields", queryParams],
    select: (response: ChurchCenterCustomFieldAPIRecordWithIncluded) =>
      mergeResourcesIncludedIntoRelationships(response),
    queryFn: () =>
      sessionApiClient.get(
        `/people/v2/people/${profileId}/church_center_custom_fields?${queryParams}`,
      ),
  })
}
